export default {
  'app.name': 'Airclass',
  'app.hi': 'Hi',
  'app.errorPageContent':
    'Please re-enter the invitation code or scan QR code to join the group',
  'app.error': 'Error',
  'app.welcomeTo': 'Welcome to',
  'app.voter': 'Voter',
  'app.message': 'Message',
  'app.pageLoading': 'Loading',
  'app.website': 'OneScreen Class',
  'back.to.answer': 'Back to Answer',
  'back.to.board': 'Back to Board'
};
